'use client';

import React, { useRef } from 'react';
import LottieRender from './LottieRender';

const OurJourney = () => {
    return (
        <section className="py-24 bg-white relative overflow-hidden">
            {/* Background Element */}
            <div className="absolute top-0 right-0 w-1/2 h-full bg-slate-50 skew-x-12 transform origin-top-right -z-10" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-2 gap-16 items-center">

                    {/* Visual - Workflow Lottie */}
                    <div className="order-2 lg:order-1 h-[400px] lg:h-[600px] w-full flex items-center justify-center">
                        <LottieRender animationPath="/animations/journey_v2.json" />
                    </div>

                    {/* Content - Timeline */}
                    <div className="order-1 lg:order-2">
                        <h2 className="text-4xl font-black text-slate-900 mb-8">
                            A Journey of <span className="text-indigo-600">Evolution</span>
                        </h2>

                        <div className="space-y-8 relative pl-8 border-l-2 border-indigo-100">
                            {[
                                { year: "2023", title: "Inception", desc: "Founded with a vision to merge code and SEO." },
                                { year: "2024", title: "Rapid Expansion", desc: "Scaled to 25+ enterprise clients and launched core platforms." },
                                { year: "2025", title: "Global Reach", desc: "Establishing international presence and AI integration." }
                            ].map((milestone, i) => (
                                <div key={i} className="relative">
                                    <span className="absolute -left-[41px] top-1 h-5 w-5 rounded-full border-4 border-white bg-indigo-600 shadow-md" />
                                    <span className="text-sm font-bold text-indigo-500 mb-1 block">{milestone.year}</span>
                                    <h3 className="text-xl font-bold text-slate-900">{milestone.title}</h3>
                                    <p className="text-slate-600 mt-2">{milestone.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurJourney;
